export const { REACT_APP_AUTH_SERVICE_ENDPOINT, REACT_APP_COMPANY_SERVICE_ENDPOINT, REACT_APP_MANAGE_SERVICE_ENDPOINT } = process.env;